import * as SG from 'styles';

import { APP_VERSION } from 'constants/appVersion';

import { Button } from 'components/Button';
import { Icon } from 'components/Icon';

import * as S from './Footer.styles';
import { StyledFooterProps } from './Footer.styles';

type FooterProps = StyledFooterProps;

const defaultProps: Partial<FooterProps> = {
  withMarginTop: false,
};

export function Footer(props: FooterProps): React.ReactElement {
  const { withMarginTop } = { ...defaultProps, ...props };

  return (
    <S.Footer withMarginTop={withMarginTop}>
      <SG.Inner>
        <S.Wrapper>
          <S.Container>
            <S.Text>
              Copyrights &copy; 2024 All Rights Reserved by Manifattura Mario Colombo &amp; C.
            </S.Text>

            <S.Text>{APP_VERSION}</S.Text>

            <S.LinkWrapper>
              <Button motive="inlineGray">Terms of Use</Button>

              <S.Separator />

              <Button motive="inlineGray">Privacy Policy</Button>
            </S.LinkWrapper>
          </S.Container>

          <S.Container asSecondary>
            <S.ContactWrapper>
              <S.IconWrapper>
                <Icon name="FiMail" />
              </S.IconWrapper>

              <S.Link>support@colmar.it</S.Link>
            </S.ContactWrapper>

            <S.ContactWrapper>
              <S.IconWrapper>
                <Icon name="FiHeadphones" />
              </S.IconWrapper>

              <S.Link>+39 039 39431</S.Link>
            </S.ContactWrapper>
          </S.Container>
        </S.Wrapper>
      </SG.Inner>
    </S.Footer>
  );
}
